const rowsPerPage = 10;

export function calculateTotalPages(totalPages?: number): number {
  if (totalPages) {
    let calculate =
      +totalPages / +rowsPerPage < 2 && +totalPages / +rowsPerPage > 1
        ? 2
        : +totalPages / +rowsPerPage <= 1
        ? 1
        : +totalPages / +rowsPerPage;
    return Math.ceil(calculate);
  } else {
    return 1;
  }
}

export function getIcon(description: string): {
  type: "success" | "error" | "default" | "warning" | undefined;
  icon: string;
} {
  switch (description) {
    case "Entrada":
      return { icon: "trending_up", type: "success" };
    case "Saida":
      return { icon: "trending_down", type: "error" };
    case "Saldo":
      return { icon: "account_balance_wallet", type: "default" };
    case "Lançamentos":
      return { icon: "line_end", type: "default" };
    default:
      return { icon: "trending_up", type: "default" };
  }
}
